var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flyover-wrapper",
    {
      staticClass: "feed-manager__flyover",
      attrs: {
        "selected-row-info": _vm.selectedRowInfo,
        "flyover-tabs": _vm.flyoverTabs,
      },
      on: { tabClick: _vm.selectedFlyoverTab, closeFlyover: _vm.closeFlyover },
    },
    [
      _vm.loader
        ? _c("mds-loader", { staticClass: "loader" })
        : _c(
            _vm.flyoverComponent,
            _vm._g(
              _vm._b(
                {
                  tag: "component",
                  staticClass: "feed-manager__flyover-content",
                },
                "component",
                _vm.flyoverProperties[true],
                false
              ),
              _vm.$listeners
            )
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }